// A single delegated controller supports both native and recovery-era sections.
function setup() {
  const sections = document.querySelectorAll('.content-section-block.is-collapsible');
  sections.forEach(section => {
    const button = section.querySelector(':scope > .section-header .section-toggle');
    const body = section.querySelector(':scope > .content-section');
    if (!button || !body) return;
    const heading = section.querySelector(':scope > .section-header h2');
    // A heading containing a native button is a disclosure, rather than an
    // apparently clickable heading plus an unrelated icon button.
    if (heading && !heading.contains(button)) {
      const label = document.createElement('span');
      label.className = 'section-toggle-label';
      while (heading.firstChild) label.append(heading.firstChild);
      button.prepend(label);
      button.removeAttribute('aria-label');
      heading.append(button);
    }
    if (!body.id) body.id = `coto-section-content-${Array.from(document.querySelectorAll('.content-section-block')).indexOf(section)}-legacy`;
    button.setAttribute('aria-controls', body.id);
    if (!heading && !button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Section content');
    button.hidden = false;
    setState(section, section.dataset.collapsedDefault === 'true' || section.classList.contains('is-collapsed'));
    button.addEventListener('click', () => setState(section, !section.classList.contains('is-collapsed')));
  });
}
function setState(section, collapsed) {
  const button = section.querySelector(':scope > .section-header .section-toggle');
  const body = section.querySelector(':scope > .content-section');
  if (!button || !body) return;
  section.classList.toggle('is-collapsed', collapsed);
  button.setAttribute('aria-expanded', String(!collapsed));
  body.hidden = collapsed;
  body.setAttribute('aria-hidden', String(collapsed));
}
function reveal(target) {
  const sections = [];
  let section = target.closest('.content-section-block.is-collapsible');
  while (section) { sections.push(section); section = section.parentElement?.closest('.content-section-block.is-collapsible'); }
  sections.reverse().forEach(section => setState(section, false));
}
// Both formats can occur together, so prevent duplicate handlers when their
// separately enqueued bundles load on the same page.
if (!window.cotoSectionController) {
  window.cotoSectionController = true;
  document.addEventListener('coto:reveal-section', event => { if (event.detail?.target) reveal(event.detail.target); });
  const revealHash = () => {
    const raw = window.location.hash.slice(1);
    let target = document.getElementById(raw);
    if (!target) {
      try { target = document.getElementById(decodeURIComponent(raw)); } catch { return; }
    }
    if (target) reveal(target);
  };
  const ready = () => { setup(); revealHash(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  window.addEventListener('hashchange', revealHash);
}
